import { useEffect, useState } from "react";
import { clientAPI } from "@/lib/client-api";

const WelcomeSection = () => {
  const [section, setSection] = useState({ title: "", paragraph1: "", paragraph2: "" });

  useEffect(() => {
    const loadData = () => {
      const data = clientAPI.getWelcomeSection();
      if (data) {
        setSection(data);
      }
    };

    loadData();

    // Listen for updates from admin panel
    window.addEventListener('contentUpdated', loadData);
    return () => window.removeEventListener('contentUpdated', loadData);
  }, []);

  return (
    <section className="py-20 px-4 bg-background">
      <div className="container mx-auto max-w-4xl">
        <div className="text-center animate-fade-in">
          <h2 className="text-4xl md:text-5xl font-bold text-foreground mb-6">
            {section.title}
          </h2>
          <div className="w-20 h-1 bg-primary mx-auto mb-8"></div>
          <p className="text-lg md:text-xl text-muted-foreground leading-relaxed mb-6">
            {section.paragraph1}
          </p>
          <p className="text-lg md:text-xl text-muted-foreground leading-relaxed">
            {section.paragraph2}
          </p>
        </div>
      </div>
    </section>
  );
};

export default WelcomeSection;
